/**
 * Where a project opens in Pages (Decision 28): its Home page, the one the
 * TeamRoom seeds once per team project (`home:<teamProjectId>`). A project
 * whose Home was deleted opens on All pages, but only once the index has
 * answered, so a slow index never flashes the list before Home.
 */
export type PagesLanding =
  | { kind: 'home'; documentId: string }
  | { kind: 'all-pages' }
  | { kind: 'pending' };

export function homePageId(teamProjectId: string): string {
  return `home:${teamProjectId}`;
}

export function pagesLanding(
  teamProjectId: string,
  documents: ReadonlyArray<{ documentId: string; trashedAt?: number | null }>,
  syncStatus: string,
): PagesLanding {
  const documentId = homePageId(teamProjectId);
  if (documents.some((document) => document.documentId === documentId && document.trashedAt == null)) {
    return { kind: 'home', documentId };
  }
  return syncStatus === 'connecting' || syncStatus === 'syncing' ? { kind: 'pending' } : { kind: 'all-pages' };
}
